import { useTranslation } from 'react-i18next'
import Link from '@/components/ui/link'

export default function ManifestoCta() {
  const { t } = useTranslation()

  return (
    <section className="px-5 sm:px-8 md:px-10 lg:px-12 max-w-[1440px] mx-auto py-16 md:py-24 lg:py-32 bg-surface-container-lowest relative overflow-hidden text-center">
      <div className="absolute top-0 left-0 w-full h-px bg-linear-to-r from-transparent via-primary to-transparent opacity-30" />

      <div className="max-w-3xl mx-auto relative z-10">
        <h2 className="font-display text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-extrabold tracking-tighter text-on-surface mb-8">
          {t('manifesto.cta.heading')}
        </h2>
        <p className="text-on-surface-variant mb-8 md:mb-12 text-base md:text-lg">
          {t('manifesto.cta.description')}
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 sm:gap-6">
          <Link
            href="/contact"
            className="w-full sm:w-auto bg-primary text-on-primary px-8 py-3.5 sm:px-10 sm:py-4 font-bold uppercase tracking-widest text-sm hover:bg-primary-fixed transition-colors cursor-pointer"
          >
            {t('manifesto.cta.requestConsulting')}
          </Link>
          {/* <Link
            href="/institucional"
            className="w-full sm:w-auto text-on-surface border border-outline-variant px-8 py-3.5 sm:px-10 sm:py-4 font-bold uppercase tracking-widest text-sm hover:bg-on-surface hover:text-surface transition-all cursor-pointer"
          >
            {t('manifesto.cta.downloadCapabilities')}
          </Link> */}
        </div>
      </div>
    </section>
  )
}
